import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import { DocumentUploadService, DocumentDownloadService } from 'gw-portals-document-js';

export default class GatewayDocumentService {
    static generateUploadToken(additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayDocument'), 'generateUploadToken', [], additionalHeaders);
    }

    static removeDocument(params, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayDocument'), 'removeDocument', [params], additionalHeaders);
    }

    static uploadDocument(file, documentMetadata, additionalHeaders) {
        return DocumentUploadService.send(getProxiedServiceUrl('gatewayUpload'), file, documentMetadata, additionalHeaders);
    }

    static downloadDocument(documentID, token) {
        return DocumentDownloadService.getDocumentLink(getProxiedServiceUrl('downloadDocument'), documentID, token);
    }

    static downloadBillingDocument(documentID, token){
        return DocumentDownloadService.getDocumentLink(getProxiedServiceUrl('billingDocumentDownload'), documentID, token);
    }
}
